var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "el-select",
    {
      ref: "select",
      staticClass: "cargo-owned-branch-select",
      style: _vm.style,
      attrs: {
        value: _vm.value,
        filterable: "",
        multiple: _vm.multiple,
        clearable: _vm.clearable,
        placeholder: _vm.placeholder
      },
      on: {
        input: _vm.onInput,
        change: _vm.onChange,
        "visible-change": _vm.onVisibleChange
      }
    },
    _vm._l(_vm.finalOptions, function(option) {
      return _c(
        "el-tooltip",
        {
          key: option.uuid,
          attrs: { content: _vm.getLabelTip(option), placement: "left" }
        },
        [
          _c("el-option", {
            attrs: { value: option.officeId, label: _vm.getLabel(option) }
          })
        ],
        1
      )
    }),
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }